// extracted by mini-css-extract-plugin
export default {"container":"ValidateReceipt_container__GtLs6","title":"ValidateReceipt_title__M-u14","card":"ValidateReceipt_card__FvFPN"};